import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DialogModule} from 'primeng/dialog';
import {PublicAuthCtaComponent} from './public-auth-cta.component';

@Component({
  selector: 'app-public-auth-dialog',
  standalone: true,
  imports: [DialogModule, TranslateModule, PublicAuthCtaComponent],
  template: `
    <p-dialog [visible]="visible" (visibleChange)="visibleChange.emit($event)"
              [modal]="true" [appendTo]="'body'" [dismissableMask]="true"
              [closeOnEscape]="true" [closable]="true" [draggable]="false" [resizable]="false"
              [style]="{width: 'min(30rem, 94vw)'}" [header]="headerKey | translate">
      <app-public-auth-cta [registrationPrimary]="true" [titleKey]="titleKey"
                           [descriptionKey]="descriptionKey" [returnUrl]="returnUrl"></app-public-auth-cta>
    </p-dialog>
  `,
})
export class PublicAuthDialogComponent {
  @Input() public visible = false;
  @Output() public visibleChange = new EventEmitter<boolean>();
  @Input() public headerKey = 'shared.public_auth_cta.title';
  @Input() public titleKey = 'shared.public_auth_cta.title';
  @Input() public descriptionKey = 'shared.public_auth_cta.description';
  @Input() public returnUrl: string | null = null;
}
